module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/project/project-grid/project-grid.component.css
// module id = ./src/app/masters/project/project-grid/project-grid.component.css
// module chunks = main